<template>
  <div class="lv-checkbox-list">
    <div class="lv-checkbox-list__title">
      <LvText bold h5>{{ $t(title) }}</LvText>
      <div v-if="toggleSelectBtn" class="lv-checkbox-list__button-wrap">
        <button class="lv-checkbox-list__button" @click="$_onClickBtn('selectAll')">
          {{ $t(selectAllBtn) }}
        </button>
        <span class="lv-checkbox-list__button-separator">|</span>
        <button class="lv-checkbox-list__button" @click="$_onClickBtn('deleteAll')">
          {{ $t(cancelAllBtn) }}
        </button>
      </div>
    </div>
    <div class="lv-checkbox-list__checkboxes">
      <div
        v-for="(checkbox, checkbox_k) in checkboxes"
        :key="checkbox_k"
        class="lv-checkbox-list__checkbox-wrap"
      >
        <label
          :class="{ disabled: $_isDisable(checkbox.key) }"
          class="lv-checkbox-list__input-label"
        >
          <input
            :id="checkbox.id"
            ref="checkbox"
            type="checkbox"
            :value="checkbox.id"
            :checked="$_getCheckboxValue(checkbox.id)"
            :disabled="$_isDisable(checkbox.key)"
            class="lv-checkbox-list__input"
            @input="$_onInput(checkbox.id)"
          />
          <div class="lv-checkbox-list__icon-wrap">
            <i
              v-if="$_getCheckboxValue(checkbox.id)"
              class="checked icon-check-box lv-checkbox-list__checkbox-icon"
            />
            <i
              v-else
              class="unchecked icon-check-box-outline-blank lv-checkbox-list__checkbox-icon"
            />
          </div>
          <div class="ml-8 lv-checkbox-list__content-wrap">
            <LvFlexBox justifyContent="space-between">
              <LvText>{{ $t(checkbox.name) }}</LvText>
              <span v-if="checkbox.trailingNumber" class="lv-checkbox-list__trailing-number">{{
                checkbox.trailingNumber
              }}</span>
            </LvFlexBox>
            <LvText v-if="checkbox.remark" blue remark>{{ $t(checkbox.remark) }}</LvText>
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import H_common from '@/helpers/common';

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    checkboxes: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    disableValue: {
      type: Array,
      default() {
        return [];
      },
    },
    selectAllBtn: {
      type: String,
      default: '全選',
    },
    cancelAllBtn: {
      type: String,
      default: '全取消',
    },
    toggleSelectBtn: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      actionList: {
        selectAll: (valueList, checkbox, index) => {
          if (index >= 0) return;
          valueList.push(checkbox.id);
        },
        deleteAll: (valueList, _, index) => {
          if (index < 0) return;
          valueList.splice(index, 1);
        },
      },
    };
  },
  methods: {
    $_onClickBtn(type) {
      if (!this.actionList[type]) return;
      const selectedValueList = [...this.value];
      this.checkboxes.forEach(checkbox => {
        if (this.disableValue.includes(checkbox.key)) return;
        const tarValueIndex = selectedValueList.findIndex(value =>
          H_common.isEqual(checkbox.id, value),
        );
        this.actionList[type](selectedValueList, checkbox, tarValueIndex);
      });
      this.$emit('input', selectedValueList);
    },
    $_isDisable(disableKey) {
      return (
        this.disableValue?.length > 0 &&
        this.disableValue?.find(disableValueItem => disableValueItem === disableKey)
      );
    },
    $_onInput($event) {
      const _index = this.value.findIndex(item => {
        return JSON.stringify(item) === JSON.stringify($event);
      });
      const _value = [...this.value];
      if (_index >= 0) {
        _value.splice(_index, 1);
      } else {
        _value.push($event);
      }
      this.$emit('input', _value);
    },
    $_getCheckboxValue(value) {
      return this.value.some(item => {
        if (Array.isArray(item) && Array.isArray(value)) {
          return JSON.stringify(item) === JSON.stringify(value);
        } else {
          return item == value;
        }
      });
    },
  },
};
</script>
